function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.61917 11.1584C3.11773 11.6614 3.4099 12.3235 3.42208 13.0213L3.42286 13.0657C3.43545 13.7872 3.15973 14.4823 2.66535 15.0223C1.68659 16.0916 1.09635 17.4999 1.10509 19.0369C1.12376 22.3608 3.95858 25.0512 7.38906 24.9983C10.8148 24.9455 13.5472 22.2083 13.4893 18.8908C13.4618 17.3158 12.8102 15.8937 11.7665 14.8413C11.2678 14.3384 10.9758 13.6764 10.9636 12.9786L10.9629 12.9341C10.9503 12.2127 11.2258 11.5175 11.7201 10.9776C12.6989 9.90824 13.2894 8.49993 13.2806 6.96297C13.2622 3.63908 10.4271 0.948664 6.99665 1.00153C3.57092 1.05432 0.838529 3.79153 0.896432 7.10881C0.923927 8.684 1.57556 10.1061 2.61917 11.1584Z",
  fill: "#070707"
});

var SvgDdm = function SvgDdm(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 26,
    viewBox: "0 0 14 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDdm, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ddm.1cf59952.svg";
export { ForwardRef as ReactComponent };